import type { MapPlanTone } from "../../enums/map";
import { MAP_CHANGE_STATUS, MAP_PLAN_TONE } from "../../enums/map";
import { mapWorkflowCounts } from "./mapModel";
import type { MapPreviewAction } from "./mapPreviewActions";

export function MapPlanStatus(props: {
  actions: MapPreviewAction[];
  dirty: boolean;
  onReset: () => void;
}) {
  const counts = () => {
    const active = props.actions.filter(
      (action) => action.change.status !== MAP_CHANGE_STATUS.DISMISSED,
    );
    const categorised = active.filter((action) => action.category !== null);
    const workflow = mapWorkflowCounts(
      categorised.map((action) => action.change),
    );
    return {
      ...workflow,
      proposed: active.length,
      unresolved: active.filter(
        (action) =>
          action.category === null ||
          action.change.status === MAP_CHANGE_STATUS.UNRESOLVED,
      ).length,
    };
  };
  return (
    <section class="map-plan-status" aria-label="Content estate plan status">
      <div class="map-plan-counts">
        <StatusCount value={counts().proposed} label="active actions" />
        <StatusCount
          value={counts().ready}
          label="accepted in preview"
          tone={MAP_PLAN_TONE.READY}
        />
        <StatusCount value={counts().review} label="needs review" />
        <StatusCount
          value={counts().unresolved}
          label="needs context"
          tone={MAP_PLAN_TONE.WARNING}
        />
      </div>
      <div class="map-plan-preview-state">
        <span>Session-local prototype state. Nothing is saved.</span>
        <button type="button" disabled={!props.dirty} onClick={props.onReset}>
          Reset local changes
        </button>
      </div>
    </section>
  );
}

function StatusCount(props: {
  value: number;
  label: string;
  tone?: MapPlanTone;
}) {
  return (
    <span class={props.tone ? `is-${props.tone}` : undefined}>
      <strong>{props.value}</strong> {props.label}
    </span>
  );
}
